import type { AssetRiskItem, AssetRiskNoRiskValue } from "./asset-risk.type";

export const ASSET_NO_RISK_VALUE: AssetRiskNoRiskValue = "no-risk";

export const ASSET_RISKS_REFERENTIAL: AssetRiskItem[] = [
  { value: 1, color: "#66c18e", name: "low" },
  { value: 2, color: "#ebbd26", name: "moderate" },
  { value: 3, color: "#e69138", name: "high" },
  { value: 4, color: "#ce5847", name: "critical" },
  { value: ASSET_NO_RISK_VALUE, color: "#b7b7b7", name: "none" },
];
